import gql from "graphql-tag";

export default gql`
  query getDownloadUrls($filePaths: [String!]!) {
    getDownloadUrls(filePaths: $filePaths)
  }
`;
